<template>
  <div class="hash-scroll-container">
    <div class="nav-box">
        <p v-for="(item, index) in navList" :key="`nav-li${index}`" @click="jump(index)" class="nav-name" :class="{'active': currentIndex === index }"><span class="main">{{item.main}}</span><span class="sub">{{item.sub}}</span></p>
    </div>
    <div class="wrapper" :id="id" :style="{height: `${boxHeight}px`}">
        <div class="img-box" :style="{height: `${boxHeight}px`}" v-for="(item, index) in imgList" :key="`wrapper-img${index}`">
            <img class="wrapper-img" :src="item.url" :style="{ width: `${item.width}px`, height: `${item.height}px` }">
        </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imgList: {
      type: Array,
      default: () => []
    },
    sectionHeight: {
      type: Array,
      default: () => []
    },
    navList: {
      type: Array,
      default: () => []
    },
    boxHeight: {
      type: Number,
      default: 520
    },
    id: {
      type: String,
      default: 'methods-wrapper'
    }
  },
  data () {
    return {
      scroll: '',
      currentIndex: 0
    //   imgList: [
    //     {
    //       url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-1.png',
    //       width: 933,
    //       height: 258
    //     },
    //     {
    //       url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-2.png',
    //       width: 888,
    //       height: 485
    //     },
    //     {
    //       url: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/cotent-scroll-3.png',
    //       width: 824,
    //       height: 477
    //     }
    //   ],
    //   navList: [
    //     {
    //       main: '6',
    //       sub: '大教学模式'
    //     },
    //     {
    //       main: '7',
    //       sub: '步备课法'
    //     },
    //     {
    //       main: '8',
    //       sub: '步教学法'
    //     }
    //   ],
    //   sectionHeight: [0, 520, 1040]
    }
  },
  methods: {
    dataScroll: function (e) {
      this.scroll = e.srcElement.scrollTop
    },
    jump (index) {
      let total = this.sectionHeight[index]
      // this.currentIndex = index
      const container = document.getElementById(this.id)
      // // Chrome
      // container.scrollTop = total
      // // Firefox
      // container.scrollTop = total
      // // Safari
      // container.pageYOffset = total
      container.scrollTo({
        top: total,
        behavior: 'smooth'
      })
      // // Chrome
      // container.scrollTop = total
      // // Firefox
      // container.scrollTop = total
      // // Safari
      // container.pageYOffset = total
      // // $('html, body').animate({
      // // 'scrollTop': total
      // // }, 400);
    },
    loadSroll: function () {
      var self = this
      let section = this.sectionHeight.find(ele => ele < self.scroll)
      console.log(section)
      for (let i = 0; i < this.sectionHeight.length; i++) {
        let temp = this.sectionHeight[i]
        if (i !== this.sectionHeight.length - 1) {
          let next = this.sectionHeight[i + 1]
          if (temp <= self.scroll && next > self.scroll) {
            this.currentIndex = i
            return
          }
        } else {
          if (temp <= self.scroll) {
            this.currentIndex = i
          }
        }
      }
    }
  },
  watch: {
    scroll: function () {
      this.loadSroll()
    }
  },
  mounted () {
    const container = document.getElementById(this.id)
    container.addEventListener('scroll', this.dataScroll)
    var sections = document.getElementsByClassName('section')
    console.log(sections)
  }
}
</script>
<style lang="scss" scoped>
    .hash-scroll-container{
        width: 100%;
        position: relative;
        margin-top: 56px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .wrapper{
            height: 500px;
            overflow-y: auto;
            width: 993px;
            .img-box{
                width: 993px;
                height: 520px;
                position: relative;
                .wrapper-img{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
            &::-webkit-scrollbar{
                display: none;
            }
        }
        .nav-box{
           width: 183px;
           .nav-name{
               position: relative;
               margin-bottom: 102px;
               display: flex;
               justify-content: flex-start;
               align-items: flex-end;
               cursor: pointer;
               &::before{
                content: ' ';
                width: 2px;
                height: 99px;
                background: rgba(40,40,40,0.3);
                position: absolute;
                bottom: -104px;
                left: 8px;
               }
               &:last-of-type{
                   margin-bottom: 0px;
                   &::before{
                      content: none;
                   }
               }
               .main{
                   font-size:54px;
                    font-family:DINCondensed-Bold;
                    font-weight:bold;
                    color:rgba(40,40,40,0.3);
                    line-height:65px;
                    margin-right: 8px;
                    position: relative;
                    top: 18px;
               }
               .sub{
                   font-size:18px;
                    font-family:PingFangSC-Semibold;
                    font-weight:600;
                    color:rgba(40,40,40,0.3);
                    line-height:25px;
               }
               &.active{
                   .main{
                       font-size: 68px;
                       color: #282828;
                   }
                   .sub{
                       color: #282828;
                       position: relative;
                       top: -9px;
                       &::after{
                           position: absolute;
                            content: ' ';
                            width:42px;
                            height:6px;
                            background:#FE5843;
                            border-radius:3px;
                            display: inline-block;
                            left: 0px;
                            bottom: -6px;
                       }
                   }
               }
           }
        }
    }
</style>
